// extracted by mini-css-extract-plugin
export default {"card":"LoginCard_card__o-j-2","title":"LoginCard_title__N-upE","noAcc":"LoginCard_noAcc__DUQdQ","tryKiiper":"LoginCard_tryKiiper__UgVOF","forgotPass":"LoginCard_forgotPass__sk6X7"};